export default __webpack_public_path__ + "static/media/brackets2.05a9dd83.png";